<p-dialog maskStyleClass="backdrop-blur-sm" [(visible)]="loginDialog" styleClass="!border-0 !bg-transparent">
  <ng-template #headless>
    <div
    class="flex flex-col px-8 py-8 gap-6 rounded-2xl"
      [style.background-image]="layoutService.isDarkTheme() ?
        'radial-gradient(circle at left top, var(--surface-ground), var(--surface-ground))' :
        'radial-gradient(circle at left top, var(--surface-card), var(--surface-card))'"
    >
    <img [src]="'/assets/images/logo-tema-' + (layoutService.isDarkTheme() ? 'escuro' : 'claro') + '.png'"
      class="block mx-auto w-[200px] object-contain" />
     
      <div class="inline-flex flex-col gap-2">
        <label for="username" class="color: var(--text-color) font-semibold">E-mail</label>
        <input pInputText id="username" class="!border-0 !p-4 color: var(--text-color) w-80"
        variant="filled" [(ngModel)]="usuario.username" />
      </div>

      <div class="inline-flex flex-col gap-2">
        <label for="password" class="color: var(--text-color) font-semibold">Senha</label>
        <input pInputText id="password" class="!border-0 !p-4 color: var(--text-color) w-80"
          type="password" variant="filled" [(ngModel)]="usuario.password"/>
      </div>

      <div class="flex items-center gap-4">
        <p-button label="Cancelar" (click)="closeDialog()" 
          styleClass="!p-4 w-full" class="w-full" severity="secondary"/>
        <p-button label="Login" (click)="login()"
          styleClass="!p-4 w-full" class="w-full" severity="primary"/>
      </div>
    </div>
  </ng-template>
</p-dialog>

<div class="progress-spinner" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
</div>